import { AddPhotoAlternate } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";

import { MediaPanel } from "../../media/index.js";
import { SelectDialogTemplate } from "../../shared/templates/index.js";
import useMedia from "./_use-media.js";

export default ({ form, setFieldValue }) => {
  const actions = {};
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <>
      <Tooltip title={t("add_media")} placement="bottom" disableTouchListener>
        <IconButton onClick={() => actions.open()}>
          <AddPhotoAlternate fontSize="small" />
        </IconButton>
      </Tooltip>
      <SelectDialogTemplate
        title="select_media"
        use={useMedia(form, t, enqueueSnackbar, setFieldValue)}
        modelPanel={MediaPanel}
        actions={actions}
      />
    </>
  );
};
